import React from 'react';

const Title = ({ title }) => (
  <div className="title--wrapper">
    <div className="container">
      <h1>{title}</h1>
    </div>
  </div>
);

export default Title;  